module.exports = __webpack_public_path__ + "img/upload.3ea4c09e.svg";